<template>
  <div class="page-works-history-add">
    <el-form
      style="width: 540px"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
    >
      <el-form-item label="作品名称" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="设计团队" prop="teamName">
        <el-input v-model="form.teamName"></el-input>
      </el-form-item>
      <el-form-item label="院校单位" prop="institution">
        <el-input v-model="form.institution"></el-input>
      </el-form-item>
      <el-form-item label="奖项标签" prop="awardLabel">
        <!-- <el-input v-model="form.awardLabel"></el-input> -->
        <el-select style="width: 100%" v-model="form.awardLabel" placeholder="">
          <el-option label="金奖" value="金奖"></el-option>
          <el-option label="银奖" value="银奖"></el-option>
          <el-option label="铜奖" value="铜奖"></el-option>
          <el-option label="优胜奖" value="优胜奖"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作品缩略图" prop="thumbnailUrl">
        <Upload v-model="form.thumbnailUrl" :token="token"></Upload>
      </el-form-item>
      <!-- <el-form-item label="作品描述" prop="description">
        <el-input type="textarea" v-model="form.description"></el-input>
      </el-form-item> -->
      <el-form-item label="设计说明" prop="designNotes">
        <el-input type="textarea" v-model="form.designNotes"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select style="width: 100%" v-model="form.type" placeholder="">
          <el-option label="产品类" value="1"></el-option>
          <el-option label="创意类" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年份" prop="year">
        <el-date-picker
          type="year"
          placeholder=""
          v-model="form.year"
          value-format="yyyy"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">
          {{ id ? '修改' : '添加' }}
        </el-button>
        <el-button @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { uid } from 'uid'
import Upload from '@/components/upload'
import { localStore } from '@/utils/store'
import * as ConstantRouter from '@/constant/router'

export default {
  components: {
    Upload
  },
  data() {
    return {
      loading: false,
      id: this.$route.params.id,
      form: {
        title: '',
        teamName: '',
        institution: '',
        awardLabel: '',
        thumbnailUrl: null,
        // description: '',
        designNotes: '',
        type: undefined,
        year: undefined
      },
      rules: {
        title: [
          { required: true, message: '作品名称不能为空', trigger: 'blur' }
        ],
        teamName: [
          { required: true, message: '设计团队不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    token() {
      return localStore.get('dashboard-token')
    }
  },
  mounted() {
    if (this.id) this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      this.loading = true
      const [err, res] = await this.$serve.jsHistoricalWork.info({
        queryId: this.id
      })
      this.loading = false
      if (err) return
      this.form = {
        title: res.title,
        teamName: res.teamName,
        institution: res.institution,
        awardLabel: res.awardLabel,
        // description: res.description,
        designNotes: res.designNotes,
        year: res.year,
        thumbnailUrl: res.thumbnailUrl
          ? {
              uid: uid(),
              status: 'success',
              url: res.thumbnailUrl
            }
          : null,
        type: res.type
      }
      if (res.jsId) {
        this.jsList = [
          {
            label: res.jsName,
            value: res.jsId
          }
        ]
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }

        const { thumbnailUrl, ...data } = this.form

        data.thumbnailUrl = thumbnailUrl.response?.data || thumbnailUrl?.url

        if (this.id) {
          this.update(data)
        } else {
          this.add(data)
        }
      })
    },
    back() {
      this.$router.push({
        name: ConstantRouter.DASHBOARD_WORKS_HISTORY
      })
    },
    async add(data) {
      this.loading = true
      const [err] = await this.$serve.jsHistoricalWork.add({
        data
      })
      this.loading = false
      if (err) return
      this.$message.success('历史作品添加成功')
      this.$router.push({
        name: ConstantRouter.DASHBOARD_WORKS_HISTORY
      })
    },
    async update(data) {
      this.loading = true
      const [err] = await this.$serve.jsHistoricalWork.update({
        data: {
          ...data,
          id: this.id
        }
      })
      this.loading = false
      if (err) return
      this.$message.success('历史作品修改成功')
      this.$router.push({
        name: ConstantRouter.DASHBOARD_WORKS_HISTORY
      })
    }
  }
}
</script>
